// src/components/SaleBanner.js
import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { apiRequest } from "../services/api";

function SaleBanner() {
  const navigate = useNavigate();
  const { lang } = useContext(LanguageContext);
  const [banner, setBanner] = useState(null);
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    apiRequest("/sale-banner")
      .then(setBanner)
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!banner) return;
    const interval = setInterval(() => {
      setAnimate(false);
      setTimeout(() => setAnimate(true), 120);
    }, 2200);
    return () => clearInterval(interval);
  }, [banner]);

  if (!banner) return null;

  return (
    <button
      onClick={() => navigate("/products/sale")}

      className="
        relative w-full overflow-hidden
        rounded-xl
        px-4 py-4 mt-3
        bg-gradient-to-br from-black via-[#0F1A12] to-black
        border border-[#2E5A2A]/60
        hover:border-[#2E5A2A]
        transition-all duration-300
        group
      "
    >
      {/* Tactical glow overlay */}
      <div className="
        absolute inset-0
        bg-[radial-gradient(circle_at_top,rgba(46,90,42,0.25),transparent_65%)]
        pointer-events-none
      " />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center">

        {/* TOP LABEL */}
        <span className="
          text-[11px] md:text-xs
          uppercase tracking-[0.25em]
          text-[#9EFFA1]
          font-bold
        ">
          {lang === "EN" ? banner.title_en : banner.title_ar}
        </span>

        {/* DISCOUNT */}
        <div
          className={`
            mt-1
            text-4xl md:text-5xl
            font-extrabold
            text-white
            drop-shadow-[0_0_18px_rgba(46,90,42,0.55)]
            transition-transform duration-200
            ${animate ? "scale-110" : "scale-100"}
          `}
        >
          {banner.discount}%
          <span className="ml-2 text-[#9EFFA1]">
            {lang === "EN" ? "OFF" : "خصم"}
          </span>
        </div>

        {/* DESCRIPTION */}
        <p className="
          mt-1
          text-[11px] md:text-xs
          text-white/70
          tracking-wide
          max-w-[90%]
        ">
          {lang === "EN"
            ? banner.description_en
            : banner.description_ar}
        </p>

        {/* CTA hint */}
        <span className="
          mt-2
          text-[10px]
          uppercase tracking-widest
          text-[#2E5A2A]
          group-hover:text-[#9EFFA1]
          transition
        ">
          {lang === "EN" ? "Shop the sale →" : "تسوق الآن ←"}
        </span>
      </div>

      {/* Bottom accent line */}
      <div className="
        absolute bottom-0 left-0 right-0 h-[2px]
        bg-gradient-to-r from-transparent via-[#2E5A2A] to-transparent
      " />
    </button>
  );
}

export default SaleBanner;
